module.exports = __webpack_public_path__ + "img/Calculative-Linescape2.e040c4ff.png";